import EventModel from '@diziner/Events/EventModel';
export class UpdatePageIndex extends EventModel {
    static publish(data) {
        PubSub.publish(this.eventName, data);
    }
    static subscribe(callback) {
        return PubSub.subscribe(this.eventName, (msg, data) => callback(data));
    }
}
UpdatePageIndex.eventName = 'UpdatePageIndex';
